import axios from 'axios'
import authHeader from '@/helpers/auth_header'
import unauthorized from '@/helpers/unauthorized'

const REST_ENDPOINT = process.env.VUE_APP_API_SERVER

export const ProgressService = {
  list,
  patient,
  save_progress,
  get_form,
};

function list () {
  return new Promise((resolve, reject) => {
    axios({
      url: `${REST_ENDPOINT}progress-note`,
      method: 'GET',
      headers: authHeader()
    }).then((res) => {
      let result = res.data;
      resolve(result)
    }).catch(function (error) {
      if(!error || !error.response) { reject(['Unknown']) }
      else if(error.response.status === 401) {
        unauthorized()
      } else {
        const data = error.response.data
        if(data && data.errors && data.errors.length > 0) {
          reject(data.errors)
        } else {
          reject(['Unknown'])
        }
      }
    })
  })
}

function get_form (pid,id) {
  return new Promise((resolve, reject) => {
    let params = ''
    if(id)params = '/'+id
    axios({
      url: `${REST_ENDPOINT}patient/${pid}/progress-note${params}`,
      method: 'GET',
      headers: authHeader()
    }).then((res) => {
      let result = res.data;
      resolve(result)
    }).catch(function (error) {
      if(!error || !error.response) { reject(['Unknown']) }
      else if(error.response.status === 401) {
        unauthorized()
      } else {
        const data = error.response.data
        if(data && data.errors && data.errors.length > 0) {
          reject(data.errors)
        } else {
          reject(['Unknown Error'])
        }
      }
    })
  })
}

function patient (id) {
  return new Promise((resolve, reject) => {
    axios({
      url: `${REST_ENDPOINT}patient/${id}`,
      method: 'GET',
      headers: authHeader()
    }).then((res) => {
      let result = res.data;
      resolve(result)
    }).catch(function (error) {
      if(!error || !error.response) { reject(['Unknown']) }
      else if(error.response.status === 401) {
        unauthorized()
      } else {
        const data = error.response.data
        if(data && data.errors && data.errors.length > 0) {
          reject(data.errors)
        } else {
          reject(['Unknown Error'])
        }
      }
    })
  })
}

function save_progress (pid,data,id) {
  let params = ''
  if(id)params = '/'+id
  return new Promise((resolve, reject) => {
    axios({
      url: REST_ENDPOINT+`patient/${pid}/progress-note${params}`,///${id}`,
      method: 'POST',
      headers: authHeader(),
      data: data
    }).then((res) => {
      resolve(res.data)
    }).catch(function (error) {
      const data = error.response.data
      if(data && data.errors && data.errors.length > 0) {
        reject(data.errors)
      } else {
        reject(['Unknown Error'])
      }
    })
  })
}